let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6wP54")).then(() => parcelRequire('bcitO'));